/**
 * Microsoft admin portal links for post-PIM-activation access.
 * URL templates use placeholders: {tenantId}, {customerDomain}, {realm}.
 * URLs match the Partner Center "Administer Services" link format.
 * {realm} is the MSP's onmicrosoft.com domain (e.g. switchconnect.onmicrosoft.com).
 */
/** MSP's own onmicrosoft.com domain used in delegated admin portal URLs */
export const MSP_REALM = "switchconnect.onmicrosoft.com";
export const ADMIN_PORTAL_LINKS = [
    // --- Core admin portals (all tiers) ---
    {
        name: "Microsoft 365 Admin Center",
        urlTemplate: "https://admin.microsoft.com/Partner/beginclientsession.aspx?CTID={tenantId}&CSDEST=o365admincenter",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2", "Tier-3", "Tier-4"],
    },
    {
        name: "Microsoft Entra Admin Center",
        urlTemplate: "https://aad.portal.azure.com/{customerDomain}",
        requiresDomain: true,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2", "Tier-3"],
    },
    {
        name: "Exchange Admin Center",
        urlTemplate: "https://admin.exchange.microsoft.com/?rfr=Admin_o365&exsvurl=1&delegatedOrg={customerDomain}&mkt=en-US&Realm={realm}",
        requiresDomain: true,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2", "Tier-3"],
    },
    {
        name: "Microsoft Teams Admin Center",
        urlTemplate: "https://admin.teams.microsoft.com/?delegatedOrg={customerDomain}",
        requiresDomain: true,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2", "Tier-3"],
    },
    // --- Mid-tier portals ---
    {
        name: "SharePoint Admin Center",
        urlTemplate: "https://admin.microsoft.com/Partner/beginclientsession.aspx?CTID={tenantId}&CSDEST=SharePoint",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2"],
    },
    {
        name: "Microsoft Intune (Endpoint Manager)",
        urlTemplate: "https://endpoint.microsoft.com/{customerDomain}",
        requiresDomain: true,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2"],
    },
    {
        name: "Microsoft 365 Apps Admin Center",
        urlTemplate: "https://config.office.com/",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2"],
    },
    // --- Security & compliance portals ---
    {
        name: "Microsoft Defender Portal",
        urlTemplate: "https://security.microsoft.com/?tid={tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Microsoft Purview (Compliance)",
        urlTemplate: "https://compliance.microsoft.com/?tid={tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Defender for Cloud Apps",
        urlTemplate: "https://portal.cloudappsecurity.com/oauth2/authorize?CTID={tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Microsoft Security Copilot",
        urlTemplate: "https://securitycopilot.microsoft.com/?tenantId={tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    // --- Azure & infrastructure portals ---
    {
        name: "Azure Portal",
        urlTemplate: "https://portal.azure.com/{customerDomain}",
        requiresDomain: true,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Power BI",
        urlTemplate: "https://app.powerbi.com/admin-portal?ctid={tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Power Platform Admin Center",
        urlTemplate: "https://admin.powerplatform.microsoft.com/account/login/{tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Dynamics 365 Business Central",
        urlTemplate: "https://businesscentral.dynamics.com/{tenantId}/admin",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Dynamics 365 Lifecycle Services",
        urlTemplate: "https://lcs.dynamics.com/Logon/Adlogon?ctid={tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    // --- Developer & subscription portals ---
    {
        name: "Visual Studio Marketplace",
        urlTemplate: "https://app.vsaex.visualstudio.com/integrationredirect/cspPartnerSignin?tenantId={tenantId}&replyto=https://marketplace.visualstudio.com",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    {
        name: "Visual Studio Subscriptions",
        urlTemplate: "https://app.vsaex.visualstudio.com/integrationredirect/cspPartnerSignin?tenantId={tenantId}&replyto=https://manage.visualstudio.com/Subscribers?act_id=2",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    // --- Health & AI portals ---
    {
        name: "Microsoft Dragon Copilot",
        urlTemplate: "https://admin.healthplatform.microsoft.com/{tenantId}",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1"],
    },
    // --- Management & monitoring portals ---
    {
        name: "Microsoft 365 Lighthouse",
        urlTemplate: "https://lighthouse.microsoft.com/",
        requiresDomain: false,
        relevantTiers: ["Tier-0", "Tier-1", "Tier-2"],
    },
];
//# sourceMappingURL=admin-portals.js.map